import "./index.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faYoutube, faLinkedin, faGithub } from "@fortawesome/free-brands-svg-icons";
export default function Social() {
    const links_social = [
    {label: " LinkedIn", path: "https://www.linkedin.com/in/alfonsbc/", icon: faLinkedin },
    {label: " YouTube", path: "https://www.youtube.com/@MateABCEnglish", icon: faYoutube },
    {label: " GitHub" , path: "https://github.com/AlfonsBC", icon: faGithub},
    ];
    return (
        <div id="nav-bar-social" className="row">
            <div className="col-md-2 col-lg-3 col-xl-4">
            </div>
            <div className="col-12 col-md-8 col-lg-6 col-xl-4 wd-flex-row-container">
            
            {links_social.map((link) => ( <div><a href={link.path} target="_blank" rel="noopener noreferrer" id="wd-social-link"><FontAwesomeIcon icon={link.icon} className="small"/>  {link.label} </a></div>
                ))}
            </div>
            <div className="col-md-2 col-lg-3 col-xl-4">
            </div>
        </div>
    );
    }